import vtkLegacyAsciiParser from './LegacyAsciiParser';
import vtkPolyDataReader from './PolyDataReader';

export default {
  vtkLegacyAsciiParser,
  vtkPolyDataReader,
};
